/**
 * Persists dismiss via EditAccountInput.hideIncentive.
 * Do not select `hideIncentive` on Account — it is not on the live schema yet
 * and selecting it breaks getItem/editAccount validation (same as the old
 * list query, which never requested it).
 */
export const mutationHideAiCreditIncentive = `
	mutation hideAiCreditIncentive($input: EditAccountInput) {
		editAccount(input: $input) {
			sortKey
		}
	}
`;
